/**
 * AdminReportsHub — top-level Reports destination.
 *
 * Master tabs are REPORT CATEGORIES. Today only Attendance Reports is live;
 * Tasks/Finance/Client are visible-but-disabled placeholders so HR sees the
 * roadmap baked into the UI.
 */
import React from 'react';
import { Users, ListTodo, Wallet, Building2 } from 'lucide-react';
import DataTabs from '../data/DataTabs';
import AttendanceReports from './AttendanceReports';
import TasksReportsHub from './TasksReportsHub';
import ClientReportsHub from './ClientReportsHub';

const ComingSoon = ({ label }) => (
  <div className="bg-white border border-dashed border-neutral-300 rounded-lg p-10 text-center">
    <div className="text-sm text-neutral-500">
      <strong className="text-neutral-800">{label}</strong> — coming soon
    </div>
    <p className="text-xs text-neutral-400 mt-2">
      Foundation built into the Reports hub. Tell me when to ship it.
    </p>
  </div>
);

const AdminReportsHub = () => {
  const tabs = [
    { key: 'attendance', label: 'Attendance Reports', icon: Users,
      render: () => <AttendanceReports /> },
    { key: 'tasks', label: 'Tasks Reports', icon: ListTodo,
      render: () => <TasksReportsHub /> },
    { key: 'finance', label: 'Finance Reports', icon: Wallet,
      render: () => <ComingSoon label="Finance Reports" /> },
    { key: 'clients', label: 'Client Reports', icon: Building2,
      render: () => <ClientReportsHub /> },
  ];
  return (
    <div className="p-6 max-w-[1600px] mx-auto" data-testid="admin-reports-hub">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-[#1a1a2e]">Reports</h1>
        <p className="text-sm text-neutral-500 mt-1">
          Comprehensive reporting across attendance, tasks, finance and clients.
        </p>
      </div>
      <DataTabs tabs={tabs} defaultTab="attendance" urlParam="reports_category" testid="reports-hub-tabs" />
    </div>
  );
};

export default AdminReportsHub;
